import React, { useState } from 'react';
import {
  Box,
  Menu, MenuItem, Tooltip,
} from '@mui/material';

function AddUnityIcon({ icon, onUnitOfMeasurement, onCustomMeasure }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip
        title="Adicionar"
      >
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: '#00C051',
            borderRadius: '50%',
            color: 'white',
          }}
          onClick={handleClick}
        >
          {icon}
        </Box>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={onUnitOfMeasurement}>Unidade de medida</MenuItem>
        <MenuItem onClick={onCustomMeasure}>Medida personalizada</MenuItem>
      </Menu>
    </>
  );
}

export default AddUnityIcon;
